import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import store from '@/store'
import Home from '@/views/Home.vue'
import base from '@/mixins/base'
import { Base64 } from 'js-base64'; // Base64 package import

Vue.use(VueRouter)


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/404',
    name: 'NotFound',
    component: () => import('@/views/404')
  },
  {
    path: '/eksik-tamamlama/online-sinavlar',
    name: 'IncompleteCompletionOnline',
    component: () => import('@/views/IncompleteCompletionOnline')
  },
  {
    path: '/eksik-tamamlama/online-sinavlar/:id/:sub_id',
    name: 'IncompleteCompletionOnlineDetail',
    component: () => import('@/views/IncompleteCompletionOnlineDetail')
  },
  {
    path: '/eksik-tamamlama/online-sinavlar/:exam_id/:lesson_id/:sub_id/:question_id',
    name: 'IncompleteCompletionOnlineQuiz',
    component: () => import('@/views/IncompleteCompletionOnlineQuiz')
  },
  {
    path: '/eksik-tamamlama',
    name: 'IncompleteCompletion',
    component: () => import('@/views/IncompleteCompletion')
  },
  {
    path: '/eksik-tamamlama/:id/:sub_id',
    name: 'IncompleteCompletionDetail',
    component: () => import('@/views/IncompleteCompletionDetail')
  },
  {
    path: '/eksik-tamamlama/:exam_id/:lesson_id/:sub_id/:question_id',
    name: 'IncompleteCompletionQuiz',
    component: () => import('@/views/IncompleteCompletionQuiz')
  },
  {
    path: '/evde-sinav',
    name: 'HomeWork',
    component: () => import('@/views/HomeWork')
  },
  {
    path: '/evde-sinav/gecmis',
    name: 'OldHomeWork',
    component: () => import('@/views/OldHomeWork')
  },
  {
    path: '/evde-sinav/:id',
    name: 'HomeWorkDetail',
    component: () => import('@/views/HomeWorkDetail')
  },
  {
    path: '/evde-sinav/:id/yazdir',
    name: 'HomeWorkPrint',
    component: () => import('@/views/HomeWorkPrint')
  },
  {
    path: '/rapor',
    name: 'Report',
    component: () => import('@/views/Report')
  },
  {
    path: '/giris-yap',
    name: 'Login',
    component: () => import('@/views/Login')
  },
  {
    path: '*',
    redirect: '/404'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  linkActiveClass: "active", // active class for non-exact links.
  linkExactActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    if (to.meta.scroll) {
      const element = document.querySelector('.router-link-exact-active');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
        return {};
      }
    }
    return savedPosition || { x: 0, y: 0 };
  },
})

router.beforeEach(async (to, from, next) => {
  NProgress.start()
  let authControl = null; // eslint-disable-line
  if (to.query.token !== undefined) {
    try {
      let token = Base64.decode(to.query.token + '==')
      token = JSON.parse(token)
      await base.methods.authData(token.kullaniciAdi, token.sifre);
      if (store.state.auth.isLogged) {
        authControl = true
      } else {
        authControl = false
      }
    } catch (e) {
      next({ name: to.name, params: to.params })
    }
  }
  // A U T H   C O N T R O L
  if (store.state.auth.isLogged) { // IS LOGGED
    authControl = true
  } else if (localStorage.getItem('token')) { // AUTH STORAGE CONTROL
    let auth = localStorage.getItem('token')
    await base.methods.authDataWithToken(auth);
    if (store.state.auth.isLogged) {
      authControl = true
    } else {
      authControl = false
    }
  } else { // IS NOT LOGGED
    authControl = false
  }

  if (!authControl && to.name != 'Login') {
    next({ name: 'Login' })
  } else if (authControl && to.name == 'Login') {
    next({ name: 'Home' })
  } else {
    // M O D U L E   C O N T R O L
    if ((to.name === 'IncompleteCompletion' || to.name === 'IncompleteCompletionDetail' || to.name === 'IncompleteCompletionQuiz') && !store.state.app.incomplete_completion) {
      next({ name: 'Home' })
    } else if ((to.name === 'HomeWork' || to.name === 'HomeWorkDetail' || to.name === 'HomeWorkPrint') && !store.state.app.home_work) {
      next({ name: 'Home' })
    } else if ((to.name === 'Report') && !store.state.app.report) {
      next({ name: 'Home' })
    } else {

      if ((to.name === 'IncompleteCompletionOnline' || to.name === 'IncompleteCompletionOnlineDetail' || to.name === 'IncompleteCompletionOnlineQuiz') && !store.state.exam.exams) {

        if (store.state.exam.incomplete_completion_online == null) {
          let examAction = await base.methods.incompleteCompletionOnlineData(store.state.auth.student_id)
          setTimeout(() => {
            if (!examAction && examAction !== undefined) {
              console.log('Sınav verileri alınamadı.')
              next({ name: 'Login' })
            } else {
              next()
            }
          }, 1000);
        } else {
          next()
        }
      } else if ((to.name === 'IncompleteCompletion' || to.name === 'IncompleteCompletionDetail' || to.name === 'IncompleteCompletionQuiz') && !store.state.exam.exams) {
        
        if (store.state.exam.incomplete_completion == null) {
          let examAction = await base.methods.incompleteCompletionData(store.state.auth.student_id)
          setTimeout(() => {
            if (!examAction && examAction !== undefined) {
              console.log('Sınav verileri alınamadı.')
              next({ name: 'Login' })
            } else {
              next()
            }
          }, 1000);
        } else {
          next()
        }
      } else {
        next()
      }
    }
  }
})
/*
router.beforeEach(async (to, from, next) => { 
  NProgress.start()
  let check = to.query.token !== undefined ? to.query.token : null
  let authControl = null; // eslint-disable-line
  if (check != null && to.query.token != localStorage.getItem('token')) {
    location.reload()
  }

  if (base.methods.auth(check)) { // data check and fixes
    if (!store.state.auth.student) {
      let token = localStorage.getItem('token')

      let studentAction = await base.methods.authData(token);
      await setTimeout(() => {
        if (!studentAction && studentAction !== undefined) {
          console.log('Kullanıcı verisi storage alanına taşınamadı.')
          next({ name: 'Login' })
        } else {
          next()
        }
      }, 1000);
    }
  }
*/
  /*
  if (to.name !== 'Login' && ! localStorage.getItem('token')) { // auth check
    console.log('Oturum anahtarı bulunamadı!')
    next({ name: 'Login' });
  } else {
    next()
  }
  */
/*
  // A U T H   C O N T R O L
  if (store.state.auth.isLogged) { // IS LOGGED
    authControl = true
  } else if (localStorage.getItem('auth')) { // AUTH STORAGE CONTROL
    let auth = Base64.decode(localStorage.getItem('auth'));
    auth = JSON.parse(auth)
    await base.methods.authData(auth.tc, auth.pass);
    if (store.state.auth.isLogged) {
      authControl = true
    } else {
      authControl = false
    }
    /*
    let authInterval = setInterval(() => {
      if (typeof store.state.auth.isLogged === 'boolean') {
        
        clearInterval(authInterval);
      }
    }, 25);
    *//*

  } else { // IS NOT LOGGED
    authControl = false
  }
*/
  
/*
  if (!authControl && to.name != 'Login') {
    next({ name: 'Login' })
  } else if (authControl && to.name == 'Login') {
    next({ name: 'Home' })
  } else {
    // M O D U L E   C O N T R O L
    if ((to.name === 'IncompleteCompletion' || to.name === 'IncompleteCompletionDetail' || to.name === 'IncompleteCompletionQuiz') && !store.state.app.incomplete_completion) {
      next({ name: 'Home' })
    } else if ((to.name === 'HomeWork' || to.name === 'HomeWorkDetail' || to.name === 'HomeWorkPrint') && !store.state.app.home_work) {
      next({ name: 'Home' })
    } else if ((to.name === 'Report') && !store.state.app.report) {
      next({ name: 'Home' })
    } else {

      if ((to.name === 'IncompleteCompletion' || to.name === 'IncompleteCompletionDetail' || to.name === 'SmallQuiz') && !store.state.exam.exams) {
        let examAction = await base.methods.incompleteCompletionData(store.state.auth.student_id)
        setTimeout(() => {
          if (!examAction && examAction !== undefined) {
            console.log('Sınav verileri alınamadı.')
            next({ name: 'Login' })
          } else {
            next()
          }
        }, 1000);
      } else {
        next()
      }
    }
  }
})
*/
router.afterEach(() => {
  NProgress.set(0.8)
  setTimeout(() => {
    NProgress.done()
  }, 200)
})

export default router
